const RolesConstants = {
    ADMIN: 1,
    STORE: 2,
    OPERATION: 3,
    MMARKT: 4
  };
      
  export default RolesConstants;